module.exports = __webpack_public_path__ + "img/text4.2613029a.webp";